import React, { useState } from 'react';
import Button from '../Button';
import translations from '../../translations/de';
import API from '../../api/tixx';
import TixxConnectModal from './TixxConnectModal';

/**
 * Runs the same subscription check the API does nightly and a few minutes
 * after every boot. A deploy is what suspends a Tixx subscription, so this
 * gives whoever notices that events stopped arriving a way to repair it on the
 * spot instead of waiting for midnight.
 */
const TixxConnectBtn = ({ ...restProps }) => {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);

    // Whoever clicks this is waiting for tickets they created in Tixx, so the
    // answer tells them what to do next rather than reporting counts. Numbers
    // only appear when something actually had to be repaired.
    const describe = ({ reachable, inactive, reactivated, failed }) => {
        if (!reachable) return { text: translations.tixx_unreachable, ok: false };
        if (failed > 0)
            return {
                text: translations.tixx_resubscribe_failed
                    .replace('{count}', reactivated)
                    .replace('{inactive}', inactive)
                    .replace('{failed}', failed),
                ok: false,
            };
        if (reactivated > 0)
            return {
                text:
                    reactivated === 1
                        ? translations.tixx_resubscribed_one
                        : translations.tixx_resubscribed.replace('{count}', reactivated),
                ok: true,
            };
        return { text: translations.tixx_all_subscribed, ok: true };
    };

    // The modal opens on the click, not on the answer: the check talks to Tixx
    // and can take a while, and the overlay is what keeps the page from being
    // clicked further in the meantime.
    const check = async () => {
        setOpen(true);
        setLoading(true);
        setResult(null);
        try {
            const res = await API.resubscribe();
            // An empty or unshaped body is the API's problem, not Tixx's, and
            // saying so is what tells the two apart at a glance.
            const data = res && res.data;
            setResult(
                data && typeof data === 'object'
                    ? describe(data)
                    : { text: translations.tixx_unexpected, ok: false },
            );
        } catch (error) {
            setResult({ text: translations.tixx_unreachable, ok: false });
        }
        setLoading(false);
    };

    return (
        <div className="tixx-connect" style={{ ...restProps.style }}>
            <Button label={translations.tixx_connect} onClick={check} loading={loading} />
            {open && (
                <TixxConnectModal
                    loading={loading}
                    result={result}
                    onClose={() => setOpen(false)}
                />
            )}
        </div>
    );
};

export default TixxConnectBtn;
